/**
 * seo-img-alt.js
 * Safety-net script that ensures every <img> on the page carries the alt text
 * already stored in the Shopify backend. Runs at DOM-ready and watches for
 * lazy-loaded / AJAX-injected images so nothing is missed by crawlers.
 *
 * Priority order for filling a missing or generic alt:
 *  1. The image object's own .alt  (already in the HTML if the Liquid passed it)
 *  2. The nearest product / collection / article title in the surrounding card
 *  3. The visible link text wrapping the image
 *  4. A cleaned-up version of the filename
 */
(function () {
  'use strict';

  var GENERIC = ['image', 'photo', 'picture', 'img', 'banner', ''];

  function isGeneric(alt) {
    return GENERIC.indexOf((alt || '').trim().toLowerCase()) !== -1;
  }

  /* Pull a meaningful string from the card / container around the image. */
  function nearestTitle(img) {
    var card = img.closest(
      '.card, .card-wrapper, .product-card, .resource-card, .collection-card, ' +
      '.card__inner, .article-card, .blog-posts__item, [data-product-card]'
    );
    if (card) {
      var heading = card.querySelector(
        '.card__heading a, .card__heading, .card__title a, .card__title, ' +
        '.resource-card__title, h2 a, h3 a, h2, h3, [data-product-title]'
      );
      if (heading) {
        var text = (heading.getAttribute('data-product-title') || heading.textContent || '').trim();
        if (text) return text;
      }
    }
    return '';
  }

  /* If the image is inside an <a>, try the link's accessible name. */
  function linkText(img) {
    var a = img.closest('a');
    if (!a) return '';
    return (a.getAttribute('aria-label') || a.getAttribute('title') || '').trim();
  }

  /* Derive a readable string from the image URL filename. */
  function fromFilename(img) {
    var src = img.currentSrc || img.src || '';
    if (!src) return '';
    try {
      var filename = src.split('/').pop().split('?')[0].split('#')[0];
      /* Strip Shopify CDN size suffixes like _800x, _grande, etc. */
      filename = filename.replace(/\.[^.]+$/, '');
      filename = filename.replace(/_\d+x\d*|_\d*x\d+/g, '');
      filename = filename.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master)/gi, '');
      filename = filename.replace(/[-_]+/g, ' ').trim();
      if (filename.length < 3) return '';
      return filename.charAt(0).toUpperCase() + filename.slice(1);
    } catch (e) {
      return '';
    }
  }

  function patchImages(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!isGeneric(img.getAttribute('alt'))) continue;

      var alt = nearestTitle(img) || linkText(img) || fromFilename(img);
      if (alt) img.setAttribute('alt', alt);
    }
  }

  /* Run once on DOM ready. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { patchImages(); });
  } else {
    patchImages();
  }

  /* Watch for dynamically injected images (AJAX pagination, quick-view, etc.). */
  if (typeof MutationObserver !== 'undefined') {
    var debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { patchImages(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
